import Resources from '../../../helpers/resources';
import {
    ENDPOINT_PATH_LIVE_MATHS,
    ENDPOINT_PATH_ALL_YEARS,
    ENDPOINT_PATH_ALL_TEACHERS
} from '../../../helpers/constants';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorsActions from '../../app/errors/errors-actions';
import liveMathsLevelPickerActions from '../../../components/live-maths-level-picker/live-maths-level-picker-actions';
import {
    ALL_YEARS,
    ALL_TEACHERS
} from '../../../components/report-filters/filter-constants';

export const LIVE_MATHS_ALL_CLASSES_RETRIEVED =
    'LIVE_MATHS_ALL_CLASSES_RETRIEVED';

function getLiveMathsData(
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId
) {
    return (dispatch, getState) => {
        const state = getState();
        if (state.isAdmin === true) {
            getAdminData(
                dispatch,
                selectedDate,
                selectedYearGroupId,
                selectedTeacherId
            );
        } else {
            getTeacherData(dispatch, selectedDate);
        }
    };
}

function getAdminData(
    dispatch,
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId
) {
    let yearGroupId = ENDPOINT_PATH_ALL_YEARS;
    let teacherId = ENDPOINT_PATH_ALL_TEACHERS;
    let resource = 'yearGroupReport';

    if (selectedYearGroupId != null && selectedYearGroupId !== ALL_YEARS) {
        yearGroupId = selectedYearGroupId;
    }
    if (selectedTeacherId != null && selectedTeacherId !== ALL_TEACHERS) {
        teacherId = selectedTeacherId;
        resource = 'teacherReport';
    }

    const params = {
        yearGroupId,
        teacherId
    };
    getData(resource, dispatch, selectedDate, params);
}

function getTeacherData(dispatch, selectedDate) {
    getData('allClassesReport', dispatch, selectedDate);
}

function getData(resource, dispatch, selectedDate, params = {}) {
    params = {
        reportType: ENDPOINT_PATH_LIVE_MATHS,
        ...DateParamHelper.getDateTypePath(selectedDate),
        ...params
    };
    Resources[resource]
        .get(params)
        .withParams(DateParamHelper.getDateQueryParams(selectedDate))
        .send()
        .then((payload) => {
            if (payload.valid) {
                dispatch(liveMathsLevelPickerActions.resetLevel());
                dispatch({
                    type: LIVE_MATHS_ALL_CLASSES_RETRIEVED,
                    payload: mapParticipationData(payload.data)
                });
            } else {
                dispatch(
                    errorsActions.addError(LIVE_MATHS_ALL_CLASSES_RETRIEVED)
                );
            }
        });
}

function mapParticipationData(data) {
    if (!data.liveMathsLevelResult) {
        return null;
    }

    const levels = [];
    for (const level in data.liveMathsLevelResult) {
        levels.push({
            id: +level,
            level,
            classes: data.liveMathsLevelResult[level].map((classData) => ({
                id: classData.id,
                name: classData.name,
                totalCorrect: mapLiveMathsScore(classData.totalCorrect),
                topScore: mapLiveMathsScore(classData.topScore),
                accuracy: mapLiveMathsScore(classData.accuracy, '%'),
                questionsPerMinute: mapLiveMathsScore(
                    classData.questionsPerMinute
                )
            }))
        });
    }
    return levels;
}

function mapLiveMathsScore(score, suffix) {
    if (score === -1) {
        return '-';
    } else if (suffix) {
        return `${score}${suffix}`;
    }
    return score;
}

export default {
    getLiveMathsData
};



// WEBPACK FOOTER //
// ./containers/live-maths/all-classes/all-classes-actions.js